import React from 'react';

interface FacebookReviewsIconProps {
  height?: number;
  className?: string;
}

export const FacebookReviewsLogo: React.FC<FacebookReviewsIconProps> = ({
  height = 26,
  className,
}) => {
  return (
    <svg
      height={height}
      width={height}
      viewBox="0 0 666.667 666.667"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="333.333" cy="333.333" r="333.333" fill="#0866ff" />
      <path
        fill="#ffffff"
        d="M462.04 423.6l14.03-91.6h-87.9v-59.44c0-25.06 12.27-49.5 51.66-49.5h39.97v-77.95s-36.27-6.2-70.95-6.2c-72.39 0-119.7 43.88-119.7 123.34v69.8h-80.47v91.6h80.47v221.5c16.14 2.53 32.72 3.86 49.62 3.86 16.9 0 33.48-1.33 49.62-3.86V423.6h73.65z"
      />
    </svg>
  );
};
